module.exports = __webpack_public_path__ + "static/publishing-about-us-0f4253e7321e8c2fc5c6685000f1c518.jpg";